import { useState, useEffect } from "react";
import { Countryapi, Stateapi, Cityapi } from "../../api/endpoints";
import Api_Instance from "../../api/Api_Instance";

const useCountries = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchCountries = async () => {
      setLoading(true);
      setError(null);
      try {
        const api = Api_Instance.unAuth();
        const response = await api("GET", Countryapi.GET_COUNTRY_API);
        setCountries(response?.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  return { countries, loading, error };
};

const States = (id) => {
  const [statedata, setStatedata] = useState([]);
  useEffect(() => {
 
    const fetchStates = async () => {
      try {
        const api = Api_Instance.unAuth();
        const response = await api("GET", `${Stateapi.GET_STATE_API}${id}/`);
        setStatedata(response?.data);
      } catch (err) {
      } finally {
      }
    };
   if(id){
      fetchStates();
    }
   
  }, [id]);

  return { statedata };
};
const Ctiy = (id) => {
  const [citydata, setCitydata] = useState([]);
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const api = Api_Instance.unAuth();
        const response = await api("GET", `${Cityapi.GET_CITY_API}${id}/`);
        setCitydata(response?.data);
      } catch (err) {
      } finally {
      }
    };
    if(id){
    fetchStates();
    }
  }, [id]);

  return { citydata };
};
export default { useCountries, States, Ctiy };
